import httpService from '@/utils/request'
import { contextPath } from '@/config/'


export const getDatabaseListApi = (params) => {
  return httpService({
    url: contextPath + '/system/dbRedis/info',
    method: 'get',
    params
  })
}

export const getAllDatabaseNotOpenListApi = (params) => {
  return httpService({
    url: contextPath + '/system/dbRedis/list/getNotOpen',
    method: 'get',
    params
  })
}

export const createDatabaseApi = (data) => {
  return httpService({
    url: contextPath + '/system/dbRedis/item',
    method: 'post',
    data
  })
}

export const modifyDatabaseApi = (data) => {
  return httpService({
    url: contextPath + '/system/dbRedis/item',
    method: 'put',
    data
  })
}

export const modifyDatabaseStatusApi = (params) => {
  return httpService({
    url: contextPath + '/system/dbRedis/item/changeDbRedisStatus',
    method: 'put',
    params
  })
}

export const deleteDatabaseApi = (params) => {
  return httpService({
    url: contextPath + '/system/dbRedis/item',
    method: 'delete',
    params
  })
}